import React from 'react';
import PropTypes from 'prop-types';
import _ from 'underscore';

import { ProgressBar } from '@bingads-webui-campaign-react/recommendation-visuals';

import { UnEditableLabelDecorator } from './uneditable-label-decorator';

export const UnEditableSimpleForm = (props) => {
  const groups = _.map(props.fields, (field, index) => {
    let text = null;
    let children = null;
    if (field.useProgressBar) {
      children = <ProgressBar percentValue={field.propertyValue} label={field.value} />;
    } else {
      text = field.text || field.value;
    }

    return (
      <UnEditableLabelDecorator key={index} label={field.label} text={text}>
        {children}
      </UnEditableLabelDecorator>);
  });

  return <React.Fragment>{groups}</React.Fragment>;
};

UnEditableSimpleForm.propTypes = {
  fields: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.string,
    text: PropTypes.string,
    value: PropTypes.string,
  })).isRequired,
};
